import React, { Component } from 'react';
import { connect } from 'react-redux';
import t from 'tcomb-form';
import { EmailRefinement } from '../../utils/tcomb-utils';
import { WebsiteRefinement, WebsiteTransformer } from '../../utils/tcomb-utils';

import { doSaveLeaderStory } from '../../actions';
import LeaderStoryPhoto from './LeaderStoryPhoto';

const leaderStoryPhotoProportion = .666;

const LeaderStorySchema = t.struct({
  email: EmailRefinement,
  first_name: t.String,
  
  last_name: t.String,
  location: t.String,
  org_name: t.String,
  career_path: t.String,
  org_info: t.String,
  
  inspiration: t.String,
  influence: t.String,
  achievement: t.String,
  get_involved: t.String,
  
  
  share: t.String,
  social_url: t.maybe(WebsiteRefinement),
})

const formOptions = {
  auto: 'none',
  fields: {
    
    email: {
      error: 'Please provide a valid email address',
      type: 'email',
      label: <div className="formLabel">Email address <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      }
    },
    

    first_name: {
      error: 'Please provide your first name',
      label: <div className="formLabel">First name <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      }
    },
    
    last_name: {
      error: 'Please provide your last name',
      label: <div className="formLabel">Last name <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      }
    },
    location: {
      error: 'Please provide your location',
      label: <div className="formLabel">Where do you live? Where are you from (if different than where you live)? <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      }
    },
    org_name: {
      error: 'Please provide your location',
      label: <div className="formLabel">What is the name of your organization? <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      }
    },

    career_path: {
      type: 'textarea',
      error: 'Please tells us about your career path',
      label: <div className="formLabel">Tell us about your career path leading up to where you are today. <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      }
    },
    
    org_info: {
      type: 'textarea',
      error: 'Please provide your organization info',
      label: <div className="formLabel">Tell us about your organization <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      },
      help: 'I.e. your mission and whom you serve',

    },
    inspiration: {
      type: 'textarea',
      error: 'Tell us about your inspirations',
      label: <div className="formLabel">What inspired you to start/or lead your organization and who has helped you along the way? <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      }
    },
    influence: {
      type: 'textarea',
      error: 'Tell us about your influences',
      label: <div className="formLabel">Who is the greatest female influence in your life? <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      }
    },
    achievement: {
      type: 'textarea',
      error: 'Please provide your location',
      label: <div className="formLabel">What do you feel is your greatest achievement? <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      }
    },
    get_involved: {
      type: 'textarea',
      error: 'Tell us about your influences',
      label: <div className="formLabel">How can WorldWideWomen readers get involved in what you are doing? <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      }
    },
    
    share: {
      type: 'textarea',
      error: 'Please share with us.',
      label: <div className="formLabel">Please share with us something that you want other women around the world to hear. <span>*</span></div>,
      attrs: {
        className: 'leaderStoryForm'
      },
    },
    
    social_url: {
      label: <div className="formLabel">Please share your preferred social media link. <span>(Optional)</span></div>,
      transformer: WebsiteTransformer,
      attrs: {
        className: 'leaderStoryForm'
      },
    },
    
  }
}

class LeaderSpotlightForm extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    formOptions: formOptions,
    formValue: {},
    throwMissingPhotoError: false,
    photoWrapperWidth: null,
    photoWrapperHeight: null,
    leaderPhotoFileType: null,
    leaderPhotoBinaryFile: null,
    leaderPhotoBinaryFileLoaded: false,
  }

  onFormChange = formValue => {
    this.setState({ formValue });
  }

  resetForm = () => {
    this.setState({formValue: {
      social_url: '',
    }})
  }

  handlePhotoBinaryFile = (file) => {
    this.setState({leaderPhotoBinaryFile: file});
    this.setState({leaderPhotoBinaryFileLoaded: true});
  }

  dataURItoBlob = (dataURI) => {
    // convert base64 to raw binary data held in a string
    const byteString = atob(dataURI.split(',')[1])

    // separate out the mime component
    const mimeString = dataURI
      .split(',')[0]
      .split(':')[1]
      .split(';')[0]

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length)
    const ia = new Uint8Array(ab)
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i)
    }
    return new Blob([ab], { type: mimeString })
  }

  getBlobFileType = (data) => {
    const byteString = data.split(';');
    let fileType = byteString[0].split('/')[1];
    this.setState({leaderPhotoFileType: fileType});
  }

  handlePhotoUpload = (file) => {
    const reader = new FileReader()

    reader.onabort = () => console.log('file reading was aborted')
    reader.onerror = () => console.log('file reading has failed')
    
    reader.onload = () => {
      var binaryStr = reader.result;
      this.getBlobFileType(binaryStr);
      
      var blob = this.dataURItoBlob(binaryStr);
      this.handlePhotoBinaryFile(blob);
    }
    
    reader.readAsDataURL(file)
  }

  

  handleSubmit = (e) => {
    e.preventDefault();
    const value = this.refs.applyForm.getValue();
    if(!value) {
      return;
    } else {
      let data = new FormData();
      for (var key in value) {
        if (key == 'social_url' && value[key] == undefined) {
          data.append(key, '')
        } else {
          data.append(key, value[key])
        }
      }
      
      if (this.state.leaderPhotoBinaryFile !== null) {
        // reset throwMissingPhotoError to false if previously false
        this.setState({throwMissingPhotoError: false})

        let picName = value.last_name + "_" + value.first_name + "." + this.state.leaderPhotoFileType;
        data.append('photo', this.state.leaderPhotoBinaryFile, picName)
      } else {
        this.setState({throwMissingPhotoError: true})
        return;
      }

      
      this.props.doSaveLeaderStory(data);
      this.props.setFormStatus(true);
      this.props.setWhichPage('thankyou')

      if (typeof(window) !== "undefined") {
        window.scrollTo(0,0)
      }
      
    }
  }

  
  componentDidMount() {
    let wrapperWidth = document.getElementById('photoWrapper').clientWidth;
    let wrapperHeight = 0;
    // Set max width
    if (wrapperWidth >= 638) {
      wrapperWidth = 638;
      wrapperHeight = 425;
    } else {
      wrapperHeight = Math.round(wrapperWidth * leaderStoryPhotoProportion);
    }

    this.setState({
      photoWrapperWidth: wrapperWidth,
      photoWrapperHeight: wrapperHeight
    });
  }

  render() {
    let photo = '';
    let photoError = '';
    if (this.state.throwMissingPhotoError) {
      photoError = <div style={{
        backgroundColor: 'red',
        width: '100%',
        padding: '0.5rem',
        color: '#ffffff',
        marginBottom: '1.0rem'
      }} className="leaderSpotlightPhotoError">Please upload your photo.</div>
    }
    return(
      <div>
        <div className="sharedStory-header"><h1 className="page-heading">Share Your Story</h1></div>

            <div className="sharedStoryWrapper">
              <form onSubmit={this.handleSubmit}>
                <t.form.Form ref="applyForm" onChange={this.onFormChange} value={this.state.formValue} type={LeaderStorySchema} options={this.state.formOptions} />
                
              </form>

              <div id="photoWrapper" style={{marginTop: '-5.0rem', padding: '0 10px'}} className="sharedStoryWrapper sharedStoryWrapper-photo">
                <p>Please upload a photo of yourself to feature alongside the story. This should be a landscape (wide rather than tall) photo (see below) with dimensions 638x425 px (if not, we will crop it as we see fit).<span style={{color: 'red'}}>*</span></p>

                {photoError}

                <LeaderStoryPhoto picture={photo}
                imgWidth={this.state.photoWrapperWidth}
                imgHeight={this.state.photoWrapperHeight}
                style={{width: this.state.photoWrapperWidth+'px', height: this.state.photoWrapperHeight+'px'}}
                onChanged={this.handlePhotoUpload} />

                <div className="sharedStoryFormBtnWrapper">
                  <button onClick={this.handleSubmit} className="my-account-submit submitButton button-primary" type="submit">Submit</button>&nbsp;
                  <button onClick={this.resetForm} className="submitButton " type="reset">Reset</button>
                </div>

              </div>
            </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state;
}
 
 export default connect(
  mapStateToProps,
  {
    doSaveLeaderStory,
  })(LeaderSpotlightForm);


// WEBPACK FOOTER //
// ./src/components/leaderStory/LeaderSpotlightForm.jsx